import React from 'react'

export default function Forthe() {
  return (
    <div className='second'>
      <div className='first-title'> 
      <h1 className="n">PRINT TO EARN</h1>
      <p className='o'>INCOME OPPORTUNITIES POWERED BY NEXT-GENERATION 3D PRINTING</p>
      <p className='oo'>
      A business startup program for creators.  Create a design, mint it as an <br /> NFT and 3D print it for your customers.</p> <br /> <br />
       <button className='btn'>PRINT TO EARN</button> 
      </div>
      <img style={{width: '350px', position: 'relative', height: '380px', marginLeft: '150px'}}  className=""src={require('/Users/macbook/metawork/src/assets/Group 6.png')} /> <br />
      
    </div>
  )
}
